"use strict";
var EPSILON = 2220446049250313e-31;
var INVERSE_EPSILON = 1 / EPSILON;
module.exports = function(n) {
  return n + INVERSE_EPSILON - INVERSE_EPSILON;
};
